/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".view-column-container{pointer-events:none;height:100%;width:320px;position:fixed;left:0;top:0;z-index:30}.view-column-container app-view-column{position:absolute;left:0;top:0;height:100%;z-index:40}"];
export { styles as styles };
